<template>
  <div class="my">
    <!-- <div class="myTopBg"></div> -->
    <el-row class="myMain">
      <el-col class="left" :span="4">
        <router-link to="/my/info">
          <span></span>
          {{ $t("myPage.information") }}
        </router-link>
        <router-link to="/my/security">
          <span></span>
          {{ $t("myPage.gle") }}
        </router-link>
        <router-link to="/my/lotteryGold">
          <span></span>
          {{ $t("myPage.withdrawals") }}
          <i class="totalUnRead" v-show="mosaicGoldStatus == 2"></i>
        </router-link>
        <router-link to="/my/finance">
          <span></span>
          {{ $t("myPage.recharge") }}
        </router-link>
        <router-link to="/my/tradingRecord">
          <span></span>
          {{ $t("myPage.security") }}
        </router-link>
        <router-link to="/my/gameRecord">
          <span></span>
          {{ $t("myPage.report") }}
        </router-link>
        <router-link to="/my/activationRecord">
          <span></span>
          {{ $t("myPage.cooperation") }}
        </router-link>
        <router-link to="/my/service">
          <span></span>
          {{ $t("myPage.Notice") }}
          <i class="totalUnRead" v-if="unreadFlag"></i>
        </router-link>
        <router-link to="/my/highRebate" v-show="rebateShow">
          <span></span>
          {{ $t("myPage.highRebate") }}
          <i class="totalUnRead" v-show="rebateRemind"></i>
        </router-link>
        <router-link to="/my/interest" v-show="interestShow">
          <span></span>
          {{ $t("myPage.treasure") }}
          <i class="totalUnRead" v-show="newShow"></i>
        </router-link>
<!--        <router-link to="/my/discount">-->
<!--          <span></span>{{ $t("myPage.mode") }}-->
<!--          <div class="news">最新</div>-->
<!--        </router-link>-->
      </el-col>
      <el-col class="right" :span="20">
        <router-view></router-view>
      </el-col>
    </el-row>
  </div>
</template>
<script>
// import "../../assets/css/my.scss";
export default {
  data() {
    return {
      rebateShow: false,
      rebateRemind: false,
      interestShow: false,
      newShow: false,
      mosaicGoldStatus: 1, // 2表示有未领取的彩金
    };
  },
  computed: {
    unreadFlag() {
      return (
        this.$store.state.msgUnReadFlag ||
        this.$store.state.noticeUnReadFlag
      );
    },
  },
  created() {
    this.getSettings();
    this.interest();
    if (this.$common.isLogin()) {
      this.$nkhttp.getBank();
      this.getMessages();
      this.getNotices();
      this.mosaicGoldPush();
    } else {
      this.$router.push({ path: "/" });
      this.$alert("请先登录", null, {
        confirmButtonText: "确定",
      });
    }
  },
  methods: {
    // 全民返利领取金额是否满足要求，满足则给红点提示
    availableAmount() {
      let that = this;
      that.$http.post(that.$api.availableAmount).then((res) => {
        if (res.code === 0) {
          if (res.data.allowance - 0 >= res.data.minCount - 0) {
            that.rebateRemind = true;
          } else {
            that.rebateRemind = false;
          }
        }
      });
    },
    // 全民返利入口显示隐藏
    getSettings() {
      let that = this;
      that.$http.get(that.$api.getSettings, "allowance_on")
        .then((res) => {
          if (res) {
            if (res.data.svalue) {
              if (res.data.svalue.allowance_on === 0) {
                that.rebateShow = false;
              } else {
                that.rebateShow = true;
                that.availableAmount();
              }
            } else {
              that.rebateShow = false;
            }
          }
        });
    },
    // 利息宝入口
    interest() {
      let that = this;
      that.$http
        .get(that.$api.getRegisterSet, "interest_global_status")
        .then((res) => {
          if (res) {
            if (res.data.svalue) {
              if (res.data.svalue.interest_global_status === 0) {
                that.interestShow = false;
              } else {
                that.interestShow = true;
                that.existRunningStatus();
              }
            } else {
              that.interestShow = false;
            }
          }
        });
    },
    // 利息宝new
    existRunningStatus() {
      let that = this;
      that.$http.get(that.$api.existRunningStatus).then((res) => {
        if (res.code === 0) {
          if (res.data) {
            that.newShow = true;
          } else {
            that.newShow = false;
          }
        }
      });
    },
    async getMessages() {
      var _this = this;
      var data = {
        currentPage: "",
        pageSize: "",
        receiverType: 0,
      };
      var res = await _this.$http.post(_this.$api.message, data);
      if (res.code == 0) {
        _this.$store.commit("msgUnReadFlag", res.data.unreadFlag);
      } else {
        var msg =
          _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
          _this.$t("errorCode.webDefault");
        this.$http.errMsg(msg);
      }
    },
    async getNotices() {
      var _this = this;
      var data = {
        createdAt: "",
        currentPage: "",
        pageSize: "",
        publishedAt: "",
        subject: "",
        type: "",
      };
      var res = await _this.$http.post(_this.$api.noticeList, data);

      if (res.code == 0) {
        _this.$store.commit("noticeUnReadFlag", res.data.unreadFlag);
      } else {
        var msg =
          _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
          _this.$t("errorCode.webDefault");
        this.$http.errMsg(msg);
      }
    },
    // 彩金推送
    mosaicGoldPush() {
      this.$http.get(this.$api.getNotReceive).then((res) => {
        if (res.code === 0) {
          if (res.data.notReceiveState) {
            // 表示有要领取的彩金
            this.$store.commit("mosaicGoldStatus", 2);
            this.mosaicGoldStatus = 2;
          } else {
            this.$store.commit("mosaicGoldStatus", 1);
            this.mosaicGoldStatus = 1;
          }
        }
      });
    },
  },
  watch: {
    "$store.state.unReadFlag"(n) {
      //实时更新公告信息的unread标志
      if (n == "message") {
        //实时获取站内信的未读标记
        this.getMessages();

        this.$store.commit("updateUnRead", "");
      } else if (n == "notice") {
        //实时获取公告的未读标记
        this.getNotices();
        this.$store.commit("updateUnRead", "");
      }
    },
    "$store.state.mosaicGoldStatus"(n) {
      // 彩金状态
      if (n) {
        this.mosaicGoldStatus = n;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.my {
    background: #f6f6f6;
  color: #000;
  font-size: 12px;
  .myTopBg {
    min-width: 1200px;
    height: 72px;
    background: #151515;
    clear: both;
  }
  .myMain {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.06);
    background: #f6f6f6;
    border: 1px solid #e8e8e8;
    width: 1200px;
    margin: 0 auto;
    // margin-top: 20px;
    .left {
      a {
        display: block;
        font-size: 14px;
        color: #444;
        height: 68px;
        padding-left: 15%;
        line-height: 68px;
        border-bottom: 1px solid #e8e8e8;
        box-shadow: 0 1px 0 #f3f3f3;
        width: 85%;
        position: relative;
        span {
          vertical-align: middle;
          margin-right: 10px;
          // width: 20px;
          // height: 20px;
          display: inline-block;
          // background: url(../../assets/images/my/my1.png) no-repeat;

          width: 25px;
          height: 25px;
        }
        .totalUnRead {
          position: absolute;
          right: 0.6rem;
          top: 0.3rem;
          transform: translateY(-50%);
          width: 0.06rem;
          height: 0.06rem;
          border-radius: 50%;
          background-color: #ff3a2b;
        }
        &:nth-child(1) {
          span {
            background: url("../../assets/images/dze/m11.png");
            background-size: 100% 100%;
          }
        }
        &:nth-child(2) {
          span {
            background: url("../../assets/images/dze/m22.png");
            background-size: 100% 100%;
          }
        }
        &:nth-child(3) {
          // display: none;
          span {
            background: url("../../assets/images/dze/m44.png");
            background-size: 100% 100%;
          }
        }
        &:nth-child(4) {
          span {
            background: url("../../assets/images/dze/m33.png");
            background-size: 100% 100%;
          }
        }
        &:nth-child(5) {
          span {
            background: url("../../assets/images/dze/m66.png");
            background-size: 100% 100%;
          }
        }
        &:nth-child(6) {
          span {
            background: url("../../assets/images/dze/t66.png");
            background-size: 100% 100%;
          }
        }
        &:nth-child(7) {
          span {
            background: url("../../assets/images/dze/t11.png");
            background-size: 100% 100%;
          }
        }
        &:nth-child(8) {
          span {
            background: url("../../assets/images/dze/t44.png");
            background-size: 100% 100%;
          }
        }
        &:nth-child(9) {
          span {
            background: url("../../assets/images/dze/m55.png");
            background-size: 100% 100%;
          }
        }
        &:nth-child(10) {
          span {
            background: url("../../assets/images/dze/t33.png");
            background-size: 100% 100%;
          }
        }
        &:nth-child(11) {
          span {
            background: url("../../assets/images/dze/t11.png");
            background-size: 100% 100%;
          }
        }
        &.router-link-active,
        &:hover {
          color: #d00;
          &:nth-child(1) {
            span {
              background: url("../../assets/images/dze/m1.png");
              background-size: 100% 100%;
            }
          }
          &:nth-child(2) {
            span {
              background: url("../../assets/images/dze/m2.png");
              background-size: 100% 100%;
            }
          }
          &:nth-child(3) {
            span {
              background: url("../../assets/images/dze/m4.png");
              background-size: 100% 100%;
            }
          }
          &:nth-child(4) {
            span {
              background: url("../../assets/images/dze/m3.png");
              background-size: 100% 100%;
            }
          }
          &:nth-child(5) {
            span {
              background: url("../../assets/images/dze/m6.png");
              background-size: 100% 100%;
            }
          }
          &:nth-child(6) {
            span {
              background: url("../../assets/images/dze/t6.png");
              background-size: 100% 100%;
            }
          }
          &:nth-child(7) {
            span {
              background: url("../../assets/images/dze/t2.png");
              background-size: 100% 100%;
            }
          }
          &:nth-child(8) {
            span {
              background: url("../../assets/images/dze/t4.png");
              background-size: 100% 100%;
            }
          }
          &:nth-child(9) {
            span {
              background: url("../../assets/images/dze/m5.png");
              background-size: 100% 100%;
            }
          }
          &:nth-child(10) {
            span {
              background: url("../../assets/images/dze/t3.png");
              background-size: 100% 100%;
            }
          }
          &:nth-child(11) {
            span {
              background: url("../../assets/images/dze/t1.png");
              background-size: 100% 100%;
            }
          }
        }
        &.router-link-active {
          border-left: 2px solid #d00;
          background: #fff;
          position: relative;
          left: -1px;
        }
      }
    }
    .right {
      border-left: 1px solid #e8e8e8;
      box-shadow: -2px 0 3px 0 rgba(0, 0, 0, 0.02);
      background: #fff;
      min-height: 760px;
      padding: 0 2.5% 2%;
    }
    .news {
      background: #d00 !important;
      color: #fff;
      line-height: 1;
      width: auto !important;
      height: 20px !important;
      padding: 0 8px;
      line-height: 20px;
      border-radius: 20px;
      font-size: 12px;
      display: inline-block;
    }
  }
}
</style>